import { Fragment, useEffect, useState } from "react"
import { MetaTags } from "react-meta-tags"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import HubUserFormBasic from "./HubUserFormBasic"
import HubUsersFormCelf from "./HubUsersFormCelf"
import HubUsersFormCmo from "./HubUsersFormCmo"
import { useDispatch, useSelector } from "react-redux"
import { addUser, addUserClean, getGroups, getProfiles } from "store/actions"
import HubUsersFormSoftSkills from "./HubUsersFormSoftSkills"
import SweetAlert from "react-bootstrap-sweetalert"

const HubUsersAdd = props => {
  const [userInfo, setUserInfo] = useState({})
  const [stage, setStage] = useState(0)
  const [finish, setFinish] = useState(false)

  const dispatch = useDispatch()

  const { insertedUser, whoIAm, loading, done, insertedUserError } =
    useSelector(state => ({
      whoIAm: state.Profile.user,
      loading: state.UserAdd.loading,
      done: state.UserAdd.done,
      insertedUser: state.UserAdd.user,
      insertedUserError: state.UserAdd.error,
    }))

  const userId = whoIAm?.idUsuario ?? 0

  useEffect(() => {
    dispatch(getProfiles())
    dispatch(getGroups())
  }, [])

  useEffect(() => {
    console.log("userInfo", userInfo)
    if (finish) {
      setFinish(false)
      saveUser()
    }
  }, [userInfo, finish])

  const saveUser = () => {
    const data = {
      userId: userId,
      nombre: userInfo.firstName,
      apellido: userInfo.lastName,
      email: userInfo.email,
      idRol: userInfo.profileId ?? userInfo.idRol,
      idGrupo: userInfo.groupId ?? userInfo.idGrupo,
      returnUri: userInfo.returnUri,
      idPosicion: userInfo.positionId,
      idUserN4assigned: userInfo.n4Assigned,
      idUserN5assigned: userInfo.n5Assigned,
      idUserN6assigned: userInfo.n6Assigned,
      idhCliente: userInfo.idh,
      nombreCliente: userInfo.clientName,
      softskillsProfileId: userInfo.softskillsProfileId,
      softskillsRegionId: userInfo.softskillsRegionId,
      softskillsPositionId: userInfo.softskillsPositionId,
    }
    dispatch(addUser(data))
  }

  return (
    <Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Registrar usuario | La Academia FEster</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col sm={4}>
              <h4>Registrar usuario</h4>
            </Col>
            <Col sm={8}>
              <Breadcrumbs
                breadcrumbItems={[
                  { key: "home", title: "La Academia Fester", link: "/start" },
                  {
                    key: "users",
                    title: "Usuarios",
                    link: "/start/adm-usuarios",
                  },
                  { key: "hub-users", title: "Registrar usuario" },
                ]}
              />
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {stage === 0 && (
                    <HubUserFormBasic
                      insert={true}
                      user
                      onConfirm={data => {
                        setUserInfo({
                          ...userInfo,
                          ...data,
                        })
                        setStage(1)
                      }}
                    />
                  )}
                  {stage === 1 && (
                    <HubUsersFormCelf
                      insert={true}
                      userFromForm={userInfo}
                      onConfirm={data => {
                        setUserInfo({
                          ...userInfo,
                          ...data,
                        })
                        setStage(2)
                      }}
                      onCancel={() => setStage(0)}
                    />
                  )}
                  {stage === 2 && (
                    <HubUsersFormCmo
                      insert={true}
                      onConfirm={data => {
                        setUserInfo({
                          ...userInfo,
                          ...data,
                        })
                        setStage(3)
                      }}
                      onCancel={() => setStage(1)}
                    />
                  )}
                  {stage === 3 && (
                    <HubUsersFormSoftSkills
                      insert={true}
                      onConfirm={data => {
                        setUserInfo({
                          ...userInfo,
                          ...data,
                        })
                        setFinish(true)
                      }}
                      onCancel={() => setStage(2)}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {done && insertedUserError === "" && (
        <SweetAlert
          title="Usuario modificado exitosamente"
          success
          confirmBtnBsStyle="success"
          onConfirm={() => {
            dispatch(addUserClean())
            props.history.push("/start/adm-usuarios")
          }}
        >
          <p>El usuario ha sido modificado exitosamente.</p>
        </SweetAlert>
      )}
    </Fragment>
  )
}

HubUsersAdd.propTypes = {
  history: PropTypes.object,
}

export default withRouter(HubUsersAdd)
